"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var plot_1 = tslib_1.__importDefault(require("../../base/plot"));
var layer_1 = tslib_1.__importDefault(require("./layer"));
var Rose = /** @class */ (function (_super) {
    tslib_1.__extends(Rose, _super);
    function Rose() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Rose.prototype.createLayers = function (props) {
        var layerProps = _.deepMix({}, props);
        layerProps.type = 'rose';
        _super.prototype.createLayers.call(this, layerProps);
    };
    Rose.getDefaultOptions = layer_1.default.getDefaultOptions;
    return Rose;
}(plot_1.default));
exports.default = Rose;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/rose/index.js
// module id = 971
// module chunks = 37